import posthog from 'posthog-js'

let initialized = false

export function initAnalytics() {
  if (initialized || !import.meta.env.VITE_POSTHOG_KEY) return
  posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com',
    autocapture: false,
    capture_pageview: true,
    disable_session_recording: true,
    sanitize_properties(properties) {
      // Strip any financial values that might leak into events
      const sensitive = /balance|amount|total|income|debt|ssn|account_number|access_token/i
      for (const key of Object.keys(properties)) {
        if (sensitive.test(key)) {
          properties[key] = '[REDACTED]'
        }
      }
      return properties
    },
  })
  initialized = true
}

export function track(event, properties) {
  if (!initialized) return
  posthog.capture(event, properties)
}

export function identify(userId, traits) {
  if (!initialized) return
  posthog.identify(userId, traits)
}

// ─── Vault events (D-630) ────────────────────────────────────
// Emitted by src/pages/Vault.jsx and src/components/VaultCard.jsx.
// All properties are safe (no financial values, no raw document content).
// Sensitive-looking keys are auto-redacted by sanitize_properties above.
export const VAULT_EVENTS = {
  // Fired when a user initiates a document upload (drop zone or button).
  //   { document_type: string, source: 'drop' | 'button' }
  UPLOAD_INITIATED:    'vault_upload_initiated',

  // Fired when extraction completes successfully and the card crystallizes.
  //   { entry_id: uuid, confidence: 'HIGH'|'MEDIUM'|'LOW', extraction_time_seconds: number }
  UPLOAD_COMPLETED:    'vault_upload_completed',

  // Fired by VaultCard whenever displayState transitions.
  //   { entry_id: uuid, from_state: string, to_state: string }
  CARD_STATE_CHANGED:  'vault_card_state_changed',

  // Fired when an insight becomes linked to a crystallized document.
  //   { entry_id: uuid, insight_id: uuid, confidence: string }
  INSIGHT_EMERGED:     'vault_insight_emerged',

  // Fired when a VaultCard renders in the error state.
  //   { entry_id: uuid, filename: string, document_type: string }
  ERROR_SHOWN:         'vault_error_shown',
}
